import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import { routes } from '@app/routes';
import { DI_TOKENS } from '@constants';
import { useInjection } from '@hooks';
import { AuthStore } from '@stores';

interface Props {
  children: ReactNode;
}

/**
 * Gate for the platform-admin panel. Non-admins hitting any `/admin/*` route
 * are redirected to their dashboard. The backend independently enforces the
 * `platform_admin` realm role — this is a UX guard, not the security boundary.
 */
export const AdminGuard: FC<Props> = observer(({ children }) => {
  const authStore = useInjection<AuthStore>(DI_TOKENS.AuthStore);

  if (!authStore.userProfile?.isPlatformAdmin) {
    return <Navigate to={routes.dashboard()} replace />;
  }

  return <>{children}</>;
});
